import { useMemo } from 'react';
import { ModelResults } from '../../model/domain/types';
import { ImpactTotals } from '../../impact/domain/types';
import { LifetimeProjection } from '../../lifetime/domain/types';
import { ReportData, ReportInput, ReportProjectConfig, ImpactMode, ProfileComparisonData } from '../domain/types';
import { extractReportData } from '../domain/reportDataExtractor';

interface UseReportDataParams {
  projectName: string;
  techType: string;
  capacityMw: number;
  location: string;
  analysisYear: number;
  isFutureProject: boolean;
  codDate?: string;
  customerName?: string;
  county?: string;
  existingProjectFlag?: boolean;
  modelResults: ModelResults | null;
  impactTotals: ImpactTotals | null;
  lifetimeProjection: LifetimeProjection | null;
  impactMode: ImpactMode;
  projectConfig?: ReportProjectConfig;
  profileComparison?: ProfileComparisonData;
}

export function useReportData(params: UseReportDataParams): ReportData | null {
  return useMemo(() => {
    if (!params.modelResults || !params.impactTotals) return null;

    const input: ReportInput = {
      projectName: params.projectName,
      techType: params.techType,
      capacityMw: params.capacityMw,
      location: params.location,
      analysisYear: params.analysisYear,
      isFutureProject: params.isFutureProject,
      codDate: params.codDate,
      customerName: params.customerName,
      county: params.county,
      existingProjectFlag: params.existingProjectFlag,
      modelResults: params.modelResults,
      impactTotals: params.impactTotals,
      lifetimeProjection: params.lifetimeProjection,
      impactMode: params.impactMode,
      projectConfig: params.projectConfig,
      profileComparison: params.profileComparison,
      profileLabel: params.modelResults.profile_label,
    };

    return extractReportData(input);
  }, [
    params.projectName,
    params.techType,
    params.capacityMw,
    params.location,
    params.analysisYear,
    params.isFutureProject,
    params.codDate,
    params.customerName,
    params.county,
    params.existingProjectFlag,
    params.modelResults,
    params.impactTotals,
    params.lifetimeProjection,
    params.impactMode,
    params.projectConfig,
    params.profileComparison,
  ]);
}
